import BaseRegulation, {BaseRegulationParams} from '../base_regulation';
import TempAccountMessageRegulationHelper from '../../helpers/temp_account_message_helper';
import {TimeSpan} from "@sparkware/app-utils";
import {TOAST_TYPES} from '../../../toaster/toaster_service_consts';
import {SYSTEM_EVENTS} from "../../../../events/events";
import Event from "../../../../utils/event";
import {GNWP_SOURCES} from '../../../../components/external_links/external_links_consts';

interface RomaniaRegulationParams extends BaseRegulationParams {
    tempAccountMessageHelper?: TempAccountMessageRegulationHelper
}

export default class RomaniaRegulation extends BaseRegulation {
    static CLASS = 'RomaniaRegulation';

	init(params: RomaniaRegulationParams) {
        super.init(params);
        this._tempAccountMessageHelper = params.tempAccountMessageHelper || TempAccountMessageRegulationHelper.create({
			serviceFactory: this.serviceFactory
		});
    }

    _tempAccountMessageHelper: TempAccountMessageRegulationHelper;

	showTempAccountMessage(closeFunc?: Function) {
        this._tempAccountMessageHelper.showTempAccountMessage({
			closeFunc: closeFunc,
			messageKey: 'ro_temp_account_message',
			footerMessageKey: 'ro_temp_account_footer_message',
			titleKey: 'temp_account_title',
			btnNameKey: 'temp_account_upload_btn'
		});
	}

    public getExternalLinksConfig() {
        return {
            'upload_document': {
                isCloseBtnAllowed: false
            }
        };
    }

    public getTempAccountGnwpSource(): string{
        return GNWP_SOURCES.DOCUMENT_UPLOAD;
    }

    protected realityCheckEnabled(): boolean {
		return true;
	}

    protected sessionTimerEnabled(): boolean {
	    return true;
    }


	protected _handleRealityCheckMessage(sessionTimer: TimeSpan): void {
	    const subTitleText = this.serviceFactory.languageService().translation('interval_reminder_body', {
            hours: sessionTimer.days * 24 + sessionTimer.hours,
            minutes: sessionTimer.minutes
        });

	    if(this.serviceFactory.hybridService().isOnDemandStandAloneGameRunning()) {
            Event.fire(SYSTEM_EVENTS.HYBRID_ALERT, subTitleText);
        } else {
            this.serviceFactory.toasterService().showToasterNotification({
                MessageID: 'romania_interval_reminder_message ' + Date.now(),
                Type: TOAST_TYPES.ACKNOWLEDGE,
                Title: this.serviceFactory.languageService().translation('interval_reminder_title'),
                SubTitle: subTitleText,
                analyticsData: {
                    category: 'romania_interval_reminder_toaster',
                    action: 'displayed'
                },
                DurationInSec: 0
            });
        }
	}
}